import { render, staticRenderFns } from "./JdsReaction.vue?vue&type=template&id=63dcdc53&scoped=true&"
import script from "./JdsReaction.vue?vue&type=script&lang=ts&"
export * from "./JdsReaction.vue?vue&type=script&lang=ts&"
import style0 from "./JdsReaction.vue?vue&type=style&index=0&id=63dcdc53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dcdc53",
  null
  
)

export default component.exports